export default __webpack_public_path__ + "static/media/HbCake1.383042f3.svg";